module.exports = __webpack_public_path__ + "static/Orkney-Bold-de9b85a9f76cae40140037d6f49f843f.woff2";